import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '@atoms/snackbar/snackbar.component';
import { ListItemTable } from '@molecules/list-item-table/list-item-table.component';
import { GenericActionModalComponent } from '@organisms/generic-action-modal/generic-action-modal.component';
import { SubscriptionService } from '@services/subscription.service';

export function buildBillingListItem(onClick: () => void): ListItemTable {
  return {
    icon: 'receipt-outline',
    title: 'Facturación y suscripción',
    subtitle: 'Gestiona tu suscripción, tu método de pago y descarga tus facturas de IAhoy.',
    externalLink: true,
    onClick
  };
}

export function openInactiveSubscriptionModal(
  dialog: MatDialog,
  expiredDate: string,
  subscriptionService: SubscriptionService,
  snackBar: MatSnackBar
): void {
  const formattedDate = expiredDate || 'fecha desconocida';
  const dialogRef = dialog.open(GenericActionModalComponent, {
    data: {
      headerTitle: 'Tu suscripción está inactiva',
      messageHtml:
        'Tu suscripción se encuentra inactiva desde el <strong>' +
        formattedDate +
        '</strong>. Renueva tu plan ahora para seguir disfrutando sin interrupciones de todos nuestros beneficios y servicios.',
      actionLabel: 'Renovar mi suscripción',
      buttonType: 'accent',
      action: () => {
        subscriptionService.openCheckout().subscribe({
          next: (response) => {
            const { url } = response as { url: string };
            window.location.href = url;
          },
          error: () => {
            dialogRef.close();
            snackBar.openFromComponent(SnackbarComponent, {
              data: {
                type: 'error',
                messageHTML: 'No se pudo iniciar el proceso de renovación. Inténtalo de nuevo más tarde.'
              },
              duration: 5000
            });
          }
        });
      }
    }
  });
}

export function openPastDueSubscriptionModal(
  dialog: MatDialog,
  subscriptionService: SubscriptionService,
  snackBar: MatSnackBar,
  expiredDate?: string
): void {
  if (!subscriptionService.canManageBilling()) {
    const memberDialogRef = dialog.open(GenericActionModalComponent, {
      data: {
        headerTitle: 'Problema con tu método de pago',
        messageHtml:
          'Ha habido un problema con el método de pago de la suscripción. Para actualizarlo, contacta con el administrador de tu cuenta.',
        actionLabel: 'Entendido',
        buttonType: 'accent',
        action: () => memberDialogRef.close()
      }
    });

    return;
  }

  const deadlineDate = expiredDate || subscriptionService.subscriptionDeadlineDate();
  const dialogRef = dialog.open(GenericActionModalComponent, {
    data: {
      headerTitle: 'Problema con tu método de pago',
      messageHtml:
        'No hemos podido renovar tu suscripción. El día <strong>' +
        deadlineDate +
        '</strong> perderás el acceso. Si quieres seguir usando IAhoy sin interrupciones añade tu método de pago aquí.',
      disclaimerText:
        'Cuando actualices tu método de pago, el cobro pendiente puede no reflejarse de inmediato en IAhoy. Puede tardar un poco hasta que confirmemos el pago.',
      actionLabel: 'Modificar método de pago',
      buttonType: 'accent',
      action: () => {
        subscriptionService.openPortal().subscribe({
          next: (response) => {
            const { url } = response as { url: string };
            window.location.href = url;
          },
          error: () => {
            dialogRef.close();
            snackBar.openFromComponent(SnackbarComponent, {
              data: {
                type: 'error',
                messageHTML: 'No se pudo abrir el portal de pago. Inténtalo de nuevo más tarde.'
              },
              duration: 5000
            });
          }
        });
      }
    }
  });
}

export function openBillingPortal(subscriptionService: SubscriptionService, snackBar: MatSnackBar): void {
  subscriptionService.openPortal().subscribe({
    next: (response) => {
      const { url } = response as { url: string };
      window.location.href = url;
    },
    error: () => {
      snackBar.openFromComponent(SnackbarComponent, {
        data: {
          type: 'error',
          messageHTML: 'No se pudo abrir la gestión de facturación. Inténtalo de nuevo más tarde.'
        },
        duration: 5000
      });
    }
  });
}
